import { mapState, mapActions, mapGetters } from 'vuex';

import { format } from 'date-fns';

import DownloadCsv from '../../_components/DownloadCsv.vue';
import PrintedQuantityPieChart from '../../_components/PrintedQuantityPieChart.vue';

export default {
  name: 'PbStatistics',
  components: {
    DownloadCsv,
    PrintedQuantityPieChart,
  },
  data() {
    return {
      dates: this.getInitialDates(),
      allowedDatesRange: this.getAllowedDatesRange(),
      statLoading: false,
    };
  },
  computed: {
    ...mapState('locations', ['suffix']),
    ...mapState('statistics', {
      labelsChart({ statisticsByMachines }) {
        const uniqueLabels = this.generateUniqueLabels(statisticsByMachines);

        return {
          settings: {
            metrics: uniqueLabels,
            stack: { labels: uniqueLabels },
          },
          data: {
            columns: ['label', ...uniqueLabels],
            rows: statisticsByMachines,
          },
        };
      },
      pieCharts(state) {
        const wrapToChartData = rows => ({ columns: ['label', 'count'], rows });
        return [
          { title: 'Quantity by operators', chartData: wrapToChartData(state.operatorsStatistics) },
          { title: 'Quantity by substrates', chartData: wrapToChartData(state.substratesStatistics) },
          { title: 'Quantity by reprints', chartData: wrapToChartData(state.reprintsStatistics) },
          { title: 'Total quantity by machines', chartData: wrapToChartData(state.totalStatistics) },
        ].filter(({ chartData: { rows } }) => Boolean(rows.length));
      },
    }),
    ...mapGetters('machines', ['machineById']),
    ...mapGetters('operators', ['operatorById']),

    startDate() {
      return this.dates[0];
    },

    endDate() {
      return `${this.dates[1]} 23:59:59`;
    },
  },
  watch: {
    dates: {
      handler(dates) {
        this.getStatistics(dates);
      },
      deep: true,
    },
    suffix() {
      this.$nextTick(() => {
        this.initData();
      });
    },
  },
  created() {
    this.initData();
  },
  methods: {
    ...mapActions('machines', ['getMachines']),
    ...mapActions('operators', ['getAllOperators']),
    ...mapActions('statistics', {
      async getStatistics(dispatch, dates = this.dates) {
        this.statLoading = true;

        try {
          await dispatch('getStatistics', {
            suffix: this.suffix,
            startDate: dates[0],
            endDate: `${dates[1]} 23:59:59`,
            machines: this.machineById,
            operators: this.operatorById,
          });
        } catch (e) {
          this.$VBlackerTheme.notification.error(e);
        } finally {
          this.statLoading = false;
        }
      },
    }),
    async initData() {
      this.statLoading = true;
      await Promise.all([
        this.getMachines({ activeOnly: false }),
        this.getAllOperators(),
      ]);
      this.getStatistics();
    },
    getInitialDates() {
      const today = new Date();
      const yesterday = new Date(today.setDate(today.getDate() - 7));
      return [
        format(yesterday, 'yyyy-MM-dd'),
        format(new Date(), 'yyyy-MM-dd'),
      ];
    },
    getAllowedDatesRange() {
      const date = new Date();
      const nextDay = date.setDate(date.getDate() + 1);
      return {
        min: `${date.getFullYear() - 2}-01-01`,
        max: (new Date(nextDay)).toISOString(),
      };
    },
    generateUniqueLabels(items) {
      const labels = [];
      items.forEach(item => labels.push(...Object.keys(item)));
      return [...new Set(labels)].filter(label => label !== 'label');
    },
  },
};
